// @flow
import env from '../../../environment';
import {
  deleteCreator,
  getCreator,
  postCreator,
  putCreator,
} from '../../../http';

import type {InputType} from '../../../entities';
export type CheckoutAIRequest = {
  id?: string,
  enabled?: boolean,
  required?: boolean,
  inputType: InputType,
  checklistConfig?: {
    options: string[],
    minSelectedOptions?: number,
    maxSelectedOptions?: number,
  },
  datePickerConfig?: {
    enabledWeekDays?: string[],
    enabledMinDaysToSelect?: boolean,
    minDaysToSelect?: number,
  },
};

export const endpoints = Object.freeze({
  GET_ADDITIONAL_INFORMATION: `${env.baseApiUrl}/im/admin/order/checkout/additional-information`,
  GET_REQUIRED_INFORMATION: `${env.baseApiUrl}/im/admin/order/required-information`,
  UPDATE_REQUIRED_INFORMATION: `${env.baseApiUrl}/im/admin/order/required-information`,
  SAVE_ORDER_STATE_MESSAGES: `${env.baseApiUrl}/im/admin/order/order-message`,
  GET_ORDER_STATE_MESSAGES: `${env.baseApiUrl}/im/admin/order/order-message`,

  // Checkout inputs
  GET_CHECKOUT_INPUT: `${env.baseApiUrl}/im/admin/order/checkout/additional-information/:id`,
  SORT_CHECKOUT_INPUT: `${env.baseApiUrl}/im/admin/order/checkout/additional-information/sort`,

  // stock settings
  GET_STORE_STOCK_SETTINGS: `${env.baseApiUrl}/im/admin/stock/setting`,
  SAVE_STORE_STOCK_SETTINGS: `${env.baseApiUrl}/im/admin/stock/setting`,
});

export const getSalesProcessAdditionalInformationApi = getCreator(
  endpoints.GET_ADDITIONAL_INFORMATION
);

export const getSalesProcessInformationApi = getCreator(
  endpoints.GET_REQUIRED_INFORMATION
);

export const getOrderStateMessagesApi = getCreator(
  endpoints.GET_ORDER_STATE_MESSAGES
);
export const updateOrderStateMessagesApi = putCreator(
  endpoints.SAVE_ORDER_STATE_MESSAGES
);

//Custom inputs

export const getCheckoutInputApi = getCreator(endpoints.GET_CHECKOUT_INPUT);

export const createCheckoutInputApi = postCreator(
  endpoints.GET_ADDITIONAL_INFORMATION
);

export const editCheckoutInputApi = putCreator(
  endpoints.GET_ADDITIONAL_INFORMATION
);

export const deleteCheckoutInputApi = deleteCreator(
  endpoints.GET_CHECKOUT_INPUT
);

export const sortCheckoutInputApi = postCreator(endpoints.SORT_CHECKOUT_INPUT);

export const getStoreStockSettingsApi = getCreator(
  endpoints.GET_STORE_STOCK_SETTINGS
);

export const saveStoreStockSettingsApi = postCreator(
  endpoints.SAVE_STORE_STOCK_SETTINGS
);
